module.exports = __webpack_public_path__ + "static/media/dragDropIcon.e3521a0a.svg";